import React from "react";
import "../../../ReactKaamvalaWebsite/Pages/Hiring/Hiring.css";
import startHiring from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/start_hiring_first_step.webp";
// import stepFourth from "../../assets/icon/start_hiring_fourth.svg";
import stepFourth from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/start_hiring_fourth.svg";
import startHiringfourth from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/start_hiring_fourth_step.webp";
import startHiring2 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/starthiringsecondstep.webp";
import starthiringsecondstep from "../../assets/wordPressKaamwala/starthiringsecondstep.webp";
import starthiringfirststep from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/start_hiring_first_step.webp";
import starthiringthird from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/starthiringthirdstep.webp";
import hiringMan from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/start_hiring_man.webp";
import startlogo from "../../../ReactKaamvalaWebsite/assets/icon/start_hiring_first.svg";
import startsecond from "../../../ReactKaamvalaWebsite/assets/icon/start_hiring_second.svg";
import { useNavigate } from "react-router-dom";
const Hiring = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="start-hiring-start">
        <section>
          <div className="">
            <div className="row">
              <div className="col-lg-12 col-md-12 p-0">
                <div className="start_hiring_container text-center">
                  <div className="start_title">
                    <h1>Start Hiring with KAAMVALA</h1>
                  </div>
                  <div className="start_hiring_title">
                    <p className="text-center">
                      Follow these simple steps to post a job and start
                      attracting top talent today!{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5 start_hiring_steps_container">
            <div className="row step_section_start_hiring py-5">
              <div className="col-lg-2">
                <div className="start_hiring_steps">
                  <h2>1</h2>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_content_main">
                <div className="start_hiring_content_img">
                  <img
                    src={startlogo}
                    width="30px"
                    height="30px"
                    alt="web and app development"
                  />
                </div>
                <div className="start_hiring_content_heading">
                  <h2>Create Your Account on Kaamvala</h2>
                </div>
                <div className="start_hiring_content_text">
                  <p>
                    Sign up or log in to Kaamvala, the top hiring app, to get
                    started. Creating an account on our top hiring app gives you
                    access to the platform's full range of hiring tools and
                    features. You'll be able to post jobs, manage listings, and
                    track applications all in one place. Don't worry, the
                    process is quick and easy, and we ensure your data is
                    secure.
                  </p>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_img_main_box">
                <div className="start_hiring_img">
                  <img
                    src={starthiringfirststep}
                    alt="web and app development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5 start_hiring_steps_container">
            <div className="row second_section_start_hiring py-5">
              <div className="col-lg-2">
                <div className="start_hiring_steps">
                  <h2>2</h2>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_content_main">
                <div className="start_hiring_content_img">
                  <img src={startsecond} alt="" width="30" height="30" />
                </div>
                <div className="start_hiring_content_heading">
                  <h2 className="text-padding-left">Customize your Profile</h2>
                </div>
                <div className="start_hiring_content_text">
                  <p className="text-padding-left">
                    Provide details about your company on Kaamvala, the top
                    hiring app. Include your industry, company size, and
                    branding elements. The more information you provide, the
                    more appealing your company will be to potential candidates
                    on the top hiring app. Add your company logo, a brief
                    description, and contact details. This helps job seekers on
                    the top hiring app get a clear understanding of your company
                    and the roles you are offering.
                  </p>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_img_main_box">
                <div className="start_hiring_img">
                  <img
                    src={starthiringsecondstep}
                    alt="web and development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5 start_hiring_steps_container">
            <div className="row step_section_start_hiring py-5">
              <div className="col-lg-2">
                <div className="start_hiring_steps">
                  <h2>3</h2>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_content_main">
                <div className="start_hiring_content_img">
                  <img
                    src={startsecond}
                    width="30px"
                    height="30px"
                    alt="web and app development"
                  />
                </div>
                <div className="start_hiring_content_heading">
                  <h2>Post Your Job!</h2>
                </div>
                <div className="start_hiring_content_text">
                  <p>
                    Enter job details on Kaamvala, the top hiring app, such as
                    the job title, description, responsibilities,
                    qualifications, and benefits. A well-crafted job post on the
                    top hiring app can attract the right candidates and set
                    clear expectations from the start. Include specifics like
                    required skills, experience levels, and any unique perks
                    your company offers. This helps in targeting the right
                    candidates on the top hiring app and ensures they have a
                    clear understanding of the job role.
                  </p>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_img_main_box">
                <div className="start_hiring_img">
                  <img
                    src={starthiringthird}
                    alt="web and app development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5 start_hiring_steps_container">
            <div className="row second_section_start_hiring py-5">
              <div className="col-lg-2">
                <div className="start_hiring_steps">
                  <h2>4</h2>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_content_main">
                <div className="start_hiring_content_img">
                  <img src={stepFourth} alt="" width="30" height="30" />
                </div>
                <div className="start_hiring_content_heading">
                  <h2 className="text-padding-left">
                    Congratulations! Your Post is Live
                  </h2>
                </div>
                <div className="start_hiring_content_text ">
                  <p className="text-padding-left">
                    Your job post is now live on Kaamvala, the top hiring app,
                    and visible to potential candidates. Check your dashboard on
                    the top hiring app to manage applications and monitor the
                    performance of your job listing. You can view the number of
                    applicants, sort through resumes, and communicate directly
                    with potential hires. Congratulations on taking the first
                    step towards building your team with the top hiring app!
                  </p>
                </div>
              </div>
              <div className="col-lg-5 start_hiring_img_main_box">
                <div className="start_hiring_img">
                  <img
                    src={startHiringfourth}
                    alt="web and development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="start_hiring_cmn_btn_main">
            <button
              type="button"
              className="btn start_hiring_cmn_btn same-hover1"
              onClick={() => navigate("/company/login")}
            >
              Hire Now!
            </button>
          </div>
        </section>
        <section>
          <div className="container-fluid py-5 px-0">
            <div className="pt-5 start_hiring_last px-2">
              <div className="start_hiring_last_content_box">
                <h2>Available For Desktop And Mobile</h2>
                <p>
                  Our solutions are designed to provide seamless experiences
                  across both desktop and mobile platforms. Whether you're
                  working from your computer or on-the-go with your smartphone,
                  you can enjoy the full functionality and convenience of our
                  services, ensuring you stay productive and connected wherever
                  you are..
                </p>
                <button
                  className="btn start_hiring_last_section_btn same-hover"
                  type="button"
                >
                  Download Now!
                </button>
              </div>
              <div className="hiring_banner_image">
                <img src={hiringMan} alt="" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default Hiring;
